export const GET_TWILIO_PHONE_NUMBERS_REQUEST = 'GET_TWILIO_PHONE_NUMBERS_REQUEST';
export const GET_TWILIO_PHONE_NUMBERS_SUCCESS = 'GET_TWILIO_PHONE_NUMBERS_SUCCESS';
export const GET_TWILIO_PHONE_NUMBERS_FAILURE = 'GET_TWILIO_PHONE_NUMBERS_FAILURE';

export const RESET_TWILIO_PHONE_NUMBERS = 'RESET_TWILIO_PHONE_NUMBERS';
